export default "__VITE_ASSET__DDP2c7i3__"